module.exports = __webpack_public_path__ + "img/logo_fundo_cinza.a6bcd73d.png";